import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormBuilder, UntypedFormControl, Validators, ControlContainer, FormGroupDirective, FormControl, FormGroup } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';
import { InventoryService } from '../../services/inventory.service';
import { GlobalsService } from '../../services/globals.service';
import { Location } from '@angular/common'
import { Subject, Observable, Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { DataTableDirective } from 'angular-datatables';
import { TableModule } from 'primeng/table';
import * as FileSaver from 'file-saver';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { PrintService } from '../../services/print.service';


import { Directive, HostListener } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { I } from '@angular/cdk/keycodes';
import { ReactiveFormsModule } from '@angular/forms';

import { BommodalComponent } from '../../shared/boms/bommodal/bommodal.component';

import { Chart, registerables } from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { combineLatest } from 'rxjs';
import { startWith, map, switchMap, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';

@Component({
	selector: 'app-inventory-view',
	templateUrl: './inventory-view.component.html',
	styleUrls: ['./inventory-view.component.scss'],
	animations: [
		trigger('grow', [ // Note the trigger name
			transition(':enter', [
				// :enter is alias to 'void => *'
				style({ height: '0', width: '0' }),
				animate('150ms', style({ width: '*', height: '*' })),
				animate('150ms', style({ opacity: 1 })),
			]),
			transition(':leave', [
				// :leave is alias to '* => void'
				animate('150ms', style({ width: '0', height: '0' })),
				animate('150ms', style({ opacity: 0 }))
			])
		]),
	],


})
export class InventoryViewComponent implements OnInit {
	@ViewChild('stockAdjust') stockadjRef: ElementRef;
	@ViewChild('controlledInfo') controlledRef: ElementRef;
	@ViewChild('productDescription') prodDesc: ElementRef;
	@ViewChild('productBenefits') beneDesc: ElementRef;
	@ViewChild('productFeatures') featDesc: ElementRef;
	@ViewChild('print_history') print_historyRef: ElementRef;

	costingbase = new UntypedFormControl('');
	descControl = new UntypedFormControl('');
	featControl = new UntypedFormControl('');
	beneControl = new UntypedFormControl('');
	overridename = new UntypedFormControl('');
	meta_title = new UntypedFormControl('');
	meta_description = new UntypedFormControl('');
	meta_keyword = new UntypedFormControl('');
	ingrControl = new UntypedFormControl('');

	// Web category editing (E-COM Description tab)
	categoryCtrl = new UntypedFormControl('');
	availableCategories: any = [];
	assignedCategories: any = [];
	filteredCategories: Observable<any[]>;

	hideshowunits = new UntypedFormControl(true);
	hideshowsales = new UntypedFormControl(true);
	hideshowcost = new UntypedFormControl(false);
	consolidated = new UntypedFormControl(true);
	defaultlocation = new UntypedFormControl('');

	filterAttributes = new UntypedFormControl('');
	charttitle = 'Item YoY';
	chart: any = false;
	itemdetails: any = [];
	itemhistory: any = [];
	selectedindex = 0;
	allattributes: any = false;
	filteredattributes: any = false;
	temp: any = false;
	user: any = [];
	binDisplay: any = false;
	hasspecial = false;

	mainImageSrc: string;
	images: any = false;
	editMatrix: any = false;
	descriptionHtmlContent: JSON;
	editing = {
		settings: false,
		extra: false,
		descriptions: false,
		attributes: false,
		images: false,
		prices: false,
		stock: false,
		purchasing: false,
	}

	isEditingAvgCost = false;
	editingAvgCostValue: number;


	addingattribute: any = false;
	color: any = '';
	config: any = [];

	stockid: any = '';
	attributeForm: FormGroup;
	updateingAttributes: any = false;
	activeParent: any = false;
	savekey: any = [];
	openCreditCount: any;
	ref_location: any = false;
	locations: any = [];
	newtitle = '';
	sending: any = false;
	currentyear = '';
	editsallowed: any = {
		discounts: true,
		editar: true,
		editbilling: true,
		editshipping: true,
		editcontact: true,
		editprofile: true,
		editnotes: true,
		takepayment: true,
	}
	libraryOpen = false;

	selectedimage = '';
	private itemHistorySubscription: Subscription;
	showItemLots = false;

	constructor(private datePipe: DatePipe, private printService: PrintService, private route: ActivatedRoute, private inventoryService: InventoryService, private location: Location, public router: Router, private modalService: NgbModal, public cdr: ChangeDetectorRef, private fb: FormBuilder, private globalSearchService: GlobalSearchService, private globalsService: GlobalsService) {

		combineLatest([
			this.globalSearchService.configsubscription,
			this.globalSearchService.user
		]).subscribe(([config, user]) => {
			this.config = config;
			this.user = user;
		});

	}



	ngOnInit(): void {

		this.globalSearchService.aiDataAvailable$.next(null);
		this.color = this.globalSearchService.getColor();

		this.globalSearchService.user.subscribe(results => {
			//only run if user is definied
			this.user = results
			if (this.user) {

				if (results.user.defaultlocation.loccode != this.ref_location) {
					this.defaultlocation.setValue(this.user.user.defaultlocation.loccode);
					this.ref_location = false;
				}
			}

			if (!this.ref_location) {
				this.ref_location = this.user.user.defaultlocation.loccode;
			}

			this.globalSearchService.locations.subscribe(async (results: any) => {
				this.locations = results;

				if (results) {
					const val = [
						this.user.user.defaultlocation.loccode
					];
					this.defaultlocation.setValue(val)
				}
			});
		});

		this.route.params.subscribe(params => {
			const itemnumber = params['id'];
			if (params['id'] != '' && params['id']) {
				this.stockid = params['id'];
				this.selectedindex = 0;
				this.globalSearchService.lastItem.next(this.stockid);
				this.loadItem();
			}
		});

		// Load available web categories for autocomplete in E-COM tab
		this.globalsService.getItemSetup().subscribe({
			next: (results: any) => {
				this.availableCategories = results?.webcategories || [];
				this.filteredCategories = this.categoryCtrl.valueChanges.pipe(
					startWith(''),
					debounceTime(400),
   					distinctUntilChanged(),
					map(value => this._filter(value || ''))
				);
			}
		});

	}

	updateYear(year: string) {

		if (this.currentyear != year) {
			this.currentyear = year;
			return true;
		}

		return false;
	}

	addTitle(text: any) {

		const locations = this.locations.filter((r: any) => {
			return r.loccode == text;
		})

		if (locations) {
			return locations.locationname
		} else {
			return '';
		}

	}



	loadData() {
		this.globalSearchService.aiDataAvailable$.next(null);
		const filter = {
			locations: this.defaultlocation.value,
			stockid: this.stockid,
			consolidated: this.consolidated.value
		};

		// Unsubscribe from any previous subscription if it exists
		if (this.itemHistorySubscription) {
			this.itemHistorySubscription.unsubscribe();
		}

		// Assign the new subscription to the itemHistorySubscription variable
		this.itemHistorySubscription = this.inventoryService.getItemHistoryByLocation(filter)
			.subscribe((results: any) => {
				this.itemhistory = results;
			});
	}


	exportXls() {
		this.sending = true;

		const encoded: string = this.globalSearchService.base64encode(this.print_historyRef.nativeElement.innerHTML);
		const data = {
			content: encoded,
			filename: this.itemdetails.item.stockid + 'YY',
		}

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.sending = false;
		});
	}

	exportPdf() {
		this.sending = true;
		const encoded: string = this.globalSearchService.base64encode(this.print_historyRef.nativeElement.innerHTML);
		const data = {
			content: encoded,
			filename: this.itemdetails.item.stockid + 'YY',
			landscape: true,
		}

		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.sending = false;
		});
	}

	getCostTotalYear(year: any) {
		const value = year.cost.reduce(function(accumulator: number, items: any) {
			const addon = parseFloat(items.value);
			return accumulator + addon;
		}, 0);

		return value;
	}

	sanitizeEditorContent(rawHtml: string): string {
	  return rawHtml
			.replace(/style="margin-left:-?\d+pt;?"/g, '') // remove margin-left
			.replace(/<br[^>]*data-cke-filler[^>]*>/g, '') // remove filler <br>
			.replace(/\s?style=""/g, ''); // clean up empty style tags
	}


	getGpClass(year: any, idx: number): string {
		const gp = this.getGpPercent(year, idx);
		if (gp >= 50) {return 'text-success';}
		if (gp >= 20) {return 'text-warning';}
		return 'text-danger';
	}

	getGpPercentTotalClass(year: any): string {
		const gp = this.getGpPercentTotalYear(year);
		if (gp >= 50) {return 'text-success';}
		if (gp >= 20) {return 'text-warning';}
		return 'text-danger';
	}


	getGpValue(year: any, idx: number): number {
		const sale = parseFloat(year.sales[idx]?.value || 0);
		const cost = parseFloat(year.cost[idx]?.value || 0);
		return sale - cost;
	}

	getGpPercent(year: any, idx: number): number {
		const sale = parseFloat(year.sales[idx]?.value || 0);
		if (sale === 0) {return 0;}
		return ((sale - parseFloat(year.cost[idx]?.value || 0)) / sale) * 100;
	}

	getGpTotalYear(year: any): number {
		return year.sales.reduce((acc: number, item: any, idx: number) => {
			return acc + this.getGpValue(year, idx);
		}, 0);
	}

	getGpPercentTotalYear(year: any): number {
		const sales = this.getSaleTotalYear(year);
		return sales ? (this.getGpTotalYear(year) / sales) * 100 : 0;
	}

	getSaleTotalYear(year: any) {
		const value = year.sales.reduce(function(accumulator: number, items: any) {
			const addon = parseFloat(items.value);
			return accumulator + addon;
		}, 0);

		return value;
	}

	getQtyTotalYear(year: any) {
		const value = year.qty.reduce(function(accumulator: number, items: any) {
			const addon = parseFloat(items.value);
			return accumulator + addon;
		}, 0);

		return value;
	}

	getGp(price, cost) {
		const sell = this.financial(price);
		if (sell === 0) {
			return 0.00;
		}

		const parsedCost = this.financial(cost);
		if (parsedCost > 0) {
			const gp = ((sell - parsedCost) / sell) * 100;
			return this.financial(gp);
		}

		// Fallback chain for cards where actualcost may be empty/zero.
		const avgCost = this.financial(this.itemdetails?.item?.cost);
		if (avgCost > 0) {
			const gp = ((sell - avgCost) / sell) * 100;
			return this.financial(gp);
		}

		const lastCost = this.financial(this.itemdetails?.item?.lastcost);
		if (lastCost > 0) {
			const gp = ((sell - lastCost) / sell) * 100;
			return this.financial(gp);
		}

		const purchaseCost = this.financial(this.itemdetails?.primarypurchase?.price);
		if (purchaseCost > 0) {
			const gp = ((sell - purchaseCost) / sell) * 100;
			return this.financial(gp);
		}

		return 0.00;
	}

	//bin roll up function incomplete
	addNegativeBins() {
		const binadd = [];
		const total_negative = 0;
		let total_onhand = 0;
		for (const key in this.itemdetails.bins) {
			for (const vals in this.itemdetails.bins[key]) {

				const thisbinval = this.financial(this.itemdetails.bins[key][vals].quantity);
				total_onhand += thisbinval;
				const bindata = this.itemdetails.bins[key][vals]
				binadd.push(bindata)
				if (thisbinval < 0) {

				}
			}
		}

		const sorted = binadd.sort((n1, n2) => n2.quantity - n1.quantity);
		this.binDisplay = sorted;
	}


	updateActiveIndex(event: any) {
		this.selectedindex = event;
		switch (this.selectedindex) {
		//force reload item;
		case 0:
			this.loadItem()
			break;
		}

		this.globalSearchService.aiDataAvailable$.next(null);
	}

	addAttribute() {
		if (this.attributeForm.valid) {
			this.inventoryService.addAttribute(this.attributeForm.value).subscribe(async (results: any) => {
				if (results.length) {
					this.filteredattributes = results;
				}
				this.attributeFormBuild();
				this.addingattribute = false;
			});
		}
	}

	attributeFormBuild() {
		this.attributeForm = this.fb.group({
			stockid: [this.itemdetails.item.stockid, Validators.required],
			key: ['', Validators.required],
			value: ['', Validators.required]
		});
	}

	toggleAddingAttribute() {
		if (!this.user.user.issalesman) {
			this.addingattribute = (this.addingattribute) ? false : true;
		}
	}

	// test(val: any, key: any){
	// 	return {
	// 		value : val,
	// 		key : key
	// 	}
	// }

	updateAttribute(stockid: string, key: string, value: any, oe: any, savekey: any, type: any) {

		if (key !== savekey) {
			this.globalSearchService.showNotification('Update the fields value before saving', 'danger', 'bottom', 'left');
			return false;
		}

		const update = {
			stockid: stockid,
			key: key,
			value: value,
			oe: oe,
			type: type
		}


		return this.inventoryService.updateAttribute(update).subscribe(async (results: any) => {
			if (results.length) {
				this.filteredattributes = results;
				this.searchAttributes(this.filterAttributes.value);
				this.globalSearchService.showNotification('Updated', 'success', 'bottom', 'left');
			}
			return true;
		});
	}


	loadItem() {

		this.inventoryService.loadItem(this.stockid).subscribe((results: any) => {

			this.globalSearchService.aiDataAvailable$.next(null);
			// Reset editing flags in one line for better readability and performance
			this.editing = {
				settings: false,
				extra: false,
				descriptions: false,
				attributes: false,
				images: false,
				prices: false,
				stock: false,
				purchasing: false,
			};


			// Destructure results for faster access
			const { item, descriptions, image } = results;

			// Update only if necessary
			this.itemdetails = results;
			this.selectedimage = image;
			const attributes = item?.attributes || [];
			this.allattributes = attributes;
			this.filteredattributes = attributes;

			// Only set costing if actualcost is present
			if (item?.actualcost) {
				this.costingbase.setValue(item.actualcost);
			}

			// Use conditional chaining to safely update form controls
			this.descControl.setValue(descriptions?.description || '');
			this.featControl.setValue(descriptions?.features || '');
			this.beneControl.setValue(descriptions?.benefits || '');
			this.ingrControl.setValue(descriptions?.ingredients || '');

			this.overridename.setValue(descriptions?.name || '');
			this.meta_title.setValue(descriptions?.meta_title || '');
			this.meta_description.setValue(descriptions?.meta_description || '');
			this.meta_keyword.setValue(descriptions?.meta_keyword || '');

			setTimeout(() => {
				const ai_data = this.extractAISummaryPayload(this.itemdetails);
				this.globalSearchService.aiDataAvailable$.next(ai_data);
				this.globalSearchService.aiDataContext$.next('inventory_data');
			}, 0);

			this.assignedCategories = results?.item?.webcategories || [];
			this.attributeFormBuild();
			this.addNegativeBins();

			if (this.stockid) {
				this.router.navigate(['/inventory/view/', this.stockid]);
			}

			this.loadData();
			this.overrideXHR();
		});
	}


	extractAISummaryPayload(data: any) {
	  const item = data.item || {};
	  const stockid = item.stockid;
	  const description = item.description;
	  const cost = parseFloat(item.materialcost || item.cost || 0);

	  // Filter out invalid/mistaken prices like RT
	  const prices = (data.prices || data.allpricing || []).filter((p: any) => p.typeabbrev !== 'RT').map((p: any) => ({
			type: p.typeabbrev,
			price: parseFloat(p.price),
			currency: p.currabrev
	  }));

	  const primaryPrice = prices.find(p => p.type === 'A1')?.price || 0;
	  const margin = primaryPrice ? ((primaryPrice - cost) / primaryPrice) * 100 : null;

	  const qoh = data.total_qoh || data.qoh || 0;
	  const lastOrdered = data.lastordered;
	  const lastPOQty = data.lastpurchqty || data.lastorderedqty;
	  const supplier = data.primarypurchase?.suppname || item?.supplier?.[0]?.suppname || 'N/A';
	  const leadTime = parseInt(data.primarypurchase?.leadtime || '0', 10);

	  const bins = data.bins || {};
	  const locations = Object.values(bins).flat().slice(0, 20).map((loc: any) => ({
			loccode: loc.loccode,
			location: loc.locationname,
			qty: parseInt(loc.quantity, 10),
			bin: loc.bin,
			reorderlevel: parseInt(loc.reorderlevel || '0', 10)
	  }));

	  const movement = (data.stockmovements || []).slice(0, 50).map((m: any) => ({
			type: m.typename,
			date: m.trandate,
			qty: Math.round(parseFloat(m.qty) * 100) / 100,
			location: m.loccode,
			reference: m.reference
	  }));

	  // Derived: grouped location data
	  const totalLocations = locations.length;
	  const zeroStockLocations = locations.filter(l => l.qty === 0).length;
	  const mainStockLocation = locations.reduce((top, loc) => loc.qty > top.qty ? loc : top, { qty: 0 });

	  // Derived: movement patterns
	  const recentSales = movement.filter(m => m.type === 'Sales Invoice');
	  const recentPOs = movement.filter(m => m.type === 'Purchase Order Delivery');
	  const transfers = movement.filter(m => m.type.includes('Transfer'));

	  const salesQty90 = recentSales.reduce((sum, m) => sum + m.qty, 0);
	  const lastSaleDate = recentSales[0]?.date || null;

	  const transferOuts = transfers.filter(t => t.qty < 0);
	  const transferIns = transfers.filter(t => t.qty > 0);
	  const transferNet = transferIns.reduce((a, t) => a + t.qty, 0) + transferOuts.reduce((a, t) => a + t.qty, 0);

	  // Clean group parsing
	  const groups = (item.groups || []).map((g: any) => ({
			name: g.name,
			count: (() => {
		  try {
					if (Array.isArray(g.group)) {return g.group.length;}
					if (typeof g.group === 'string') {return JSON.parse(g.group || '[]').length;}
		  } catch (_) {}
		  return 0;
			})()
	  }));

	  const salesVelocity = this.calculateSalesVelocity(recentSales, salesQty90);
	  const reorderRecommendation = this.calculateReorderPoint(salesVelocity, leadTime, qoh);
	  const seasonalPattern = this.analyzeSeasonalPattern(recentSales);
	  const supplierMetrics = this.calculateSupplierMetrics(data.primarypurchase, recentPOs, leadTime);
	  const categoryContext = this.getCategoryContext(groups, item);
	  const locationComparison = this.compareLocations(locations);

	  const payload: any = {
			stockid,
			description,
			cost: Math.round(cost * 100) / 100,
			prices: prices.map((p: any) => ({
				type: p.type,
				price: Math.round(p.price * 100) / 100,
				currency: p.currency
			})),
			margin: margin ? Math.round(margin * 100) / 100 : null,
			qoh,
			supplier,
			leadTime,
			lastOrdered,
			lastPOQty,
			primaryPrice: Math.round(primaryPrice * 100) / 100,
			locations,
			movement,
			totalLocations,
			zeroStockLocations,
			mainStockLocation: mainStockLocation.qty > 0 ? mainStockLocation : null,
			recentSalesCount: recentSales.length,
			recentSalesQty: Math.round(Math.abs(salesQty90) * 100) / 100,
			lastSaleDate,
			lastPOCount: recentPOs.length,
			transferNet: Math.round(transferNet * 100) / 100,
			groups: groups.filter((g: any) => g.count > 0)
	  };

	  if (salesVelocity) {
			payload.salesVelocity = salesVelocity;
	  }

	  if (reorderRecommendation) {
			payload.reorderRecommendation = reorderRecommendation;
	  }

	  if (seasonalPattern) {
			payload.seasonalPattern = seasonalPattern;
	  }

	  if (supplierMetrics) {
			payload.supplierMetrics = supplierMetrics;
	  }

	  if (categoryContext) {
			payload.categoryContext = categoryContext;
	  }

	  if (locationComparison) {
			payload.locationComparison = locationComparison;
	  }

	  Object.keys(payload).forEach(key => {
			if (payload[key] === null || payload[key] === undefined || payload[key] === '') {
				delete payload[key];
			} else if (typeof payload[key] === 'object' && !Array.isArray(payload[key])) {
				Object.keys(payload[key]).forEach(subKey => {
					if (payload[key][subKey] === null || payload[key][subKey] === undefined || payload[key][subKey] === '') {
						delete payload[key][subKey];
					}
				});
				if (Object.keys(payload[key]).length === 0) {
					delete payload[key];
				}
			}
	  });

	  return payload;
	}

	private calculateSalesVelocity(recentSales: any[], totalQty90: number): any {
		if (!recentSales || recentSales.length === 0) {return null;}

		const now = new Date();
		const ninetyDaysAgo = new Date(now.getTime() - (90 * 24 * 60 * 60 * 1000));
		const salesInPeriod = recentSales.filter(s => {
			const saleDate = new Date(s.date);
			return saleDate >= ninetyDaysAgo;
		});

		if (salesInPeriod.length === 0) {return null;}

		const unitsPerWeek = totalQty90 / 12.86;
		const unitsPerMonth = totalQty90 / 3;
		const averageOrderSize = totalQty90 / salesInPeriod.length;

		return {
			unitsPerWeek: Math.round(unitsPerWeek * 100) / 100,
			unitsPerMonth: Math.round(unitsPerMonth * 100) / 100,
			averageOrderSize: Math.round(averageOrderSize * 100) / 100,
			period: '90_days'
		};
	}

	private calculateReorderPoint(salesVelocity: any, leadTime: number, currentQoh: number): any {
		if (!salesVelocity || !leadTime) {return null;}

		const weeklyDemand = salesVelocity.unitsPerWeek || 0;
		const safetyStock = weeklyDemand * 2;
		const reorderPoint = Math.ceil((weeklyDemand * (leadTime / 7)) + safetyStock);
		const recommendedOrderQty = Math.max(reorderPoint - currentQoh, 0);

		return {
			reorderPoint: reorderPoint,
			currentQoh: currentQoh,
			recommendedOrderQty: recommendedOrderQty > 0 ? recommendedOrderQty : null,
			safetyStock: Math.ceil(safetyStock),
			status: currentQoh <= reorderPoint ? 'Reorder_Needed' : 'Adequate_Stock'
		};
	}

	private analyzeSeasonalPattern(recentSales: any[]): any {
		if (!recentSales || recentSales.length < 4) {return null;}

		const monthlySales: { [key: number]: number } = {};
		recentSales.forEach(sale => {
			const date = new Date(sale.date);
			const month = date.getMonth();
			monthlySales[month] = (monthlySales[month] || 0) + Math.abs(sale.qty);
		});

		const months = Object.keys(monthlySales).map(Number);
		if (months.length < 3) {return null;}

		const values = months.map(m => monthlySales[m]);
		const avg = values.reduce((a, b) => a + b, 0) / values.length;
		const maxMonth = months[values.indexOf(Math.max(...values))];
		const minMonth = months[values.indexOf(Math.min(...values))];

		const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

		return {
			peakMonth: monthNames[maxMonth],
			lowMonth: monthNames[minMonth],
			variation: Math.round(((Math.max(...values) - Math.min(...values)) / avg) * 100),
			hasSeasonality: Math.max(...values) / Math.min(...values) > 1.5
		};
	}

	private calculateSupplierMetrics(primaryPurchase: any, recentPOs: any[], leadTime: number): any {
		if (!primaryPurchase && (!recentPOs || recentPOs.length === 0)) {return null;}

		const avgLeadTime = leadTime || 0;
		const poCount = recentPOs ? recentPOs.length : 0;
		const avgPOQty = recentPOs && recentPOs.length > 0
			? recentPOs.reduce((sum, po) => sum + Math.abs(po.qty || 0), 0) / recentPOs.length
			: null;

		const performance = {
			avgLeadTimeDays: avgLeadTime,
			recentPOsCount: poCount,
			avgPOQty: avgPOQty ? Math.round(avgPOQty * 100) / 100 : null,
			performanceRating: avgLeadTime <= 7 ? 'Excellent' : avgLeadTime <= 14 ? 'Good' : avgLeadTime <= 30 ? 'Fair' : 'Poor'
		};

		return performance;
	}

	private getCategoryContext(groups: any[], item: any): any {
		if (!groups || groups.length === 0) {return null;}

		const activeGroups = groups.filter((g: any) => g.count > 0);
		if (activeGroups.length === 0) {return null;}

		return {
			categories: activeGroups.map((g: any) => g.name),
			categoryCount: activeGroups.length,
			primaryCategory: activeGroups[0]?.name || null
		};
	}

	private compareLocations(locations: any[]): any {
		if (!locations || locations.length < 2) {return null;}

		const totalQty = locations.reduce((sum, loc) => sum + loc.qty, 0);
		const locationDistribution = locations.map(loc => ({
			location: loc.location,
			loccode: loc.loccode,
			qty: loc.qty,
			percentage: totalQty > 0 ? Math.round((loc.qty / totalQty) * 100) : 0,
			hasReorderLevel: loc.reorderlevel > 0,
			belowReorderLevel: loc.reorderlevel > 0 && loc.qty < loc.reorderlevel
		}));

		return {
			totalLocations: locations.length,
			locationsWithStock: locations.filter(l => l.qty > 0).length,
			locationsBelowReorder: locationDistribution.filter(l => l.belowReorderLevel).length,
			distribution: locationDistribution
		};
	}

	editDescriptionByType(input: String) {
		if (input == 'description') {
			this.descriptionHtmlContent = JSON.parse(JSON.stringify({
				html: '<pre>' + this.itemdetails.descriptions.description + '</pre>',
				type: 'description'
			}));
		}
		if (input == 'features') {
			this.descriptionHtmlContent = JSON.parse(JSON.stringify({
				html: '<pre>' + this.itemdetails.descriptions.features + '</pre>',
				type: 'features'
			}));
		}
		if (input == 'benefits') {
			this.descriptionHtmlContent = JSON.parse(JSON.stringify({
				html: '<pre>' + this.itemdetails.descriptions.benefits + '</pre>',
				type: 'benefits'
			}));
		}
		this.modalService.open(this.prodDesc, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {
			const input = JSON.parse(JSON.stringify({ stockid: this.itemdetails.item.stockid, input: this.descriptionHtmlContent['html'] }));
			if (result == 'save description') {
				this.inventoryService.updateItemDescription(input).subscribe(result => {
					this.loadItem();
				});
			}
			if (result == 'save features') {
				this.inventoryService.updateItemFeatures(input).subscribe(result => {
					this.loadItem();
				});
			}
			if (result == 'save benefits') {
				this.inventoryService.updateItemBenefits(input).subscribe(result => {
					this.loadItem();
				});
			}
		}, (reason) => {

		});
	}

	updateForm(control, event) {
		control.setValue(event)
	}

	private _filter(value: any): any[] {
		if (typeof value === 'string' && value.trim() !== '') {
			const filterValue = value.toLowerCase().split(' ');

			let cats = [];
			filterValue.forEach((part) => {
				if(cats.length){
					cats = (cats || []).filter((category: any) => (category.label || '').toLowerCase().includes(part));
				}else{
					cats = (this.availableCategories || []).filter((category: any) => (category.label || '').toLowerCase().includes(part));
				}
			})

			return cats;
		}

		return this.availableCategories || [];
	}

	addCategory(category: any) {
		const categoryId = category?.value ?? category?.category_id ?? category?.id;
		if (!categoryId) {return;}

		const already = (this.assignedCategories || []).find((c: any) => c.category_id === categoryId);
		if (!already) {
			this.assignedCategories = [...(this.assignedCategories || []), {
				stockid: this.itemdetails?.item?.stockid,
				category_id: categoryId,
				name: category?.name ?? category?.label,
				label: category?.label ?? category?.name
			}];
		}
		this.categoryCtrl.setValue('');
	}

	removeCategory(category_id: string) {
		this.assignedCategories = (this.assignedCategories || []).filter((c: any) => c.category_id !== category_id);
	}

	saveDescriptions() {

		const data = {
			stockid: this.itemdetails.item.stockid,
			description: this.descControl.value,
			features: this.featControl.value,
			benefits: this.beneControl.value,
			name: this.overridename.value,
			meta_title: this.meta_title.value,
			meta_description: this.meta_description.value,
			meta_keyword: this.meta_keyword.value,
		}

		if (this.config.env.package == 'beauty') {
			data['ingredients'] = this.ingrControl.value
		}

		this.inventoryService.updateItemDescription(data).pipe(
			switchMap((result: any) => {
				const payload = {
					stockid: this.itemdetails.item.stockid,
					categories: this.assignedCategories || []
				};
				return this.inventoryService.assignCategories(payload);
			})
		).subscribe(() => {
			this.loadItem();
		});
	}

	selectItemLookup(event: any) {
		this.router.navigate(['./orders/entry/' + event.header.debtorno + '/' + event.header.branchcode]);
		//http://localhost:4200/#/orders/entry/107/00
	}

	invoiceOrder(event: any) {
		this.router.navigate(['orders/invoice/' + event + '/dispatch']);
	}

	moveToPo(order: any) {
		this.router.navigate(['/purchasing/' + order.header.supplierno]);
	}

	updateItem(event: any) {

		this.editing = {
			settings: false,
			extra: false,
			descriptions: false,
			attributes: false,
			images: false,
			prices: false,
			stock: false,
			purchasing: false,
		}

		this.loadItem()

	}

	closeAdj() {
		this.modalService.dismissAll();
		this.loadItem()
	}

	searchAttributes(value: string) {
		this.filteredattributes = this.globalSearchService.filterItem(this.allattributes, value, 'label,value,key');
	}

	toggleEditPurchasing() {
		if (!this.user.user.issalesman && this.user.user.viewcost) {
			this.selectedindex = (this.selectedindex != 4) ? 4 : 0;
		}
	}

	toggleEditPrices() {
		if (!this.user.user.issalesman) {
			this.editing.prices = this.editing.prices ? false : true;
		}
	}
	toggleEditExtra() {
		if (!this.user.user.issalesman) {
			this.editing.extra = (this.editing.extra) ? false : true;
		}
	}
	toggleEditImages() {
		if (!this.user.user.issalesman) {
			this.editing.images = (this.editing.images) ? false : true;
		}
	}
	toggleEditSettings() {
		if (!this.user.user.issalesman) {
			this.editing.settings = (this.editing.settings) ? false : true;
		}
	}
	toggleEditStock() {
		if (!this.user.user.issalesman) {
			this.modalService.open(this.stockadjRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

			}, (reason) => {

			});
		}
	}

	setActualCost(newValue: any) {
		if (!this.user.user.issalesman) {
			this.itemdetails.item.actualcost = newValue;
			const data = {
				stockid: this.itemdetails.item.stockid,
				actualcost: this.financial(newValue),
			}
			this.inventoryService.setActualCost(data).subscribe(r => {
				this.loadItem()
			})
		}
	}

	percent(x) {

		if (Number.isNaN(x)) {
			x = 0
		}

		return parseFloat(Number.parseFloat(x).toFixed(4));
	}

	financial(x) {

		if (Number.isNaN(x)) {
			x = 0
		}

		return parseFloat(Number.parseFloat(x).toFixed(2));
	}

	getSpecial(code: any) {

		let special = [];
		this.hasspecial = false;
		if (this.itemdetails.special) {
			for (const key in this.itemdetails.special.prices) {
				if (key == code) {
					special = this.itemdetails.special.prices[key];
					if (special) {
						this.hasspecial = true;
					}
				}
			}
		}

		return this.financial(special);

	}

	getPlmMarkup(code: any) {
		const markup = 'N/A';
		const operator = '';
		let returnval = '';

		if (this.itemdetails.item.plm) {
			const plm = this.itemdetails.item.plm.filter(r => {
				return r.typeabbrev == code;
			})[0];
			if (plm) {
				switch (plm.operator) {
				case '1':
					returnval = ' +' + this.financial(plm.amount) + '$'
					break;
				case '2':
					returnval = ' *' + this.percent(plm.amount) + '%'
					break;
				default:
					returnval = ' -' + this.financial(plm.amount) + '$'
					break;
				}
			}
		}

		return returnval;
	}

	back(): void {
		this.location.back()
	}

	ngOnChanges(changes: any) {

	}

	openLookup() {
		this.activeParent = this.stockid;
	}

	setData(data: any = []) {

		const dataset = data;


		const _labels = [];
		const _series = [];
		const datapoints = [];

		data.years.forEach((r, index) => {
			const value = {
				value: r.total,
				meta: r.label,
				name: r.label,
				label: r.label,
				data: r.total
			}
			_labels.push(r.label)

			if (this.config.env.package == 'tires') {
				_series.push(r.qty)
			} else {
				_series.push(r.total)
			}

			datapoints.push(value)
		});

		// 		if(this.grouplocations.value) {
		//
		// 		}

		return {
			labels: _labels,
			datasets: [{
				label: this.charttitle,
				data: _series,
				borderWidth: 1,
				fill: false,
				// backgroundColor: [
				//   'rgba(255, 99, 132, 0.2)',
				//   'rgba(255, 159, 64, 0.2)',
				//   'rgba(255, 205, 86, 0.2)',
				//   'rgba(75, 192, 192, 0.2)',
				//   'rgba(54, 162, 235, 0.2)',
				//   'rgba(153, 102, 255, 0.2)',
				//   'rgba(201, 203, 207, 0.2)'
				// ],
			}]
		};
	}

	changeMainImage(image: any) {
		if (this.itemdetails.item) {
			this.itemdetails.item.full_size_image = image.image;
			this.selectedimage = image.file;
		}
	}

	removeMainImage() {

		const data = {
			item: this.itemdetails.item,
			image: (this.selectedimage) ? this.selectedimage : this.itemdetails.item.image
		}

		this.inventoryService.removeMainImage(data).subscribe(result => {
			this.loadItem();
		});
	}

	removeImage(input: any) {
		this.inventoryService.removeImage(input).subscribe(result => {
			this.loadItem();
		});
	}

	getPriceForKey(key: string): number {
		if (this.itemdetails.item.special) {
			if (this.itemdetails.item.special.prices) {
				if (this.itemdetails.item.special.prices.hasOwnProperty(key)) {
					const price = this.itemdetails.item.special.prices[key];

					if (price) {
						return this.financial(price);
					}
				}
			}
		}
		return 0;
	}

	getFirstPriceValue(prices: {
		[key: string]: any
	}): any {
		const keys = Object.keys(prices);
		if (keys.length === 0) {
			return 0;
		}
		const firstKey = keys[0];
		return prices[firstKey];
	}

	formatDate(date: string): string {
		return this.datePipe.transform(date, 'shortDate');
	}

	isExpired(date: string): boolean {
		return new Date(date) < new Date();
	}

	getDisplayPricing() {
		const rows = Array.isArray(this.itemdetails?.allpricing) ? this.itemdetails.allpricing : [];
		if (!rows.length) {
			return [];
		}

		const now = new Date();
		const byType: { [key: string]: any[] } = {};
		for (const row of rows) {
			const type = String(row?.typeabbrev || '').trim();
			if (!type) {
				continue;
			}
			if (!byType[type]) {
				byType[type] = [];
			}
			byType[type].push(row);
		}

		const chosen: any[] = [];
		for (const type of Object.keys(byType)) {
			const candidates = byType[type];
			const active = candidates.filter((r) => {
				const start = new Date(r.startdate);
				const end = new Date(r.enddate);
				return !Number.isNaN(start.getTime()) && !Number.isNaN(end.getTime()) && start <= now && end >= now;
			});

			const pool = active.length ? active : candidates;
			pool.sort((a, b) => {
				const aStart = new Date(a.startdate).getTime();
				const bStart = new Date(b.startdate).getTime();
				const safeA = Number.isNaN(aStart) ? 0 : aStart;
				const safeB = Number.isNaN(bStart) ? 0 : bStart;
				return safeB - safeA;
			});
			chosen.push(pool[0]);
		}

		chosen.sort((a, b) => String(a.typeabbrev).localeCompare(String(b.typeabbrev)));
		return chosen;
	}

	getItemStock() {
		switch (this.config.env.package) {
		case 'beauty':
			return this.getFilteredItemStock();
			break;
		default:
			return this.getFilteredItemStockTires();
			break;
		}
	}

	getFilteredItemStockTires() {
		return this.itemdetails.itemstock.filter(item => {

			const bins = this.itemdetails.bins[item.locccode];
			// Include the item if its loccode matches the default warehouse
			if (this.config.defaults.warehouse === item.loccode) {
				if (bins) {
					const defaultBin = bins.find(bin => bin.defaultbin === '1');
					if (defaultBin) {
						item.defaultBin = defaultBin.bin; // Store the default bin in the item
						return true;
					}
				}
				return true;
			}

			const itemQuantity = Number(item.quantity);
			let controlledQuantity = 0;
			if (this.itemdetails.item.controlled && this.itemdetails.serials[item.loccode]) {
				this.itemdetails.serials[item.loccode].forEach(controlled => {
					controlledQuantity += Number(controlled.quantity);
				});
				item.controlledQuantity = controlledQuantity;
			}

			// Include the item if its quantity is non-zero
			if (itemQuantity !== 0) {
				return true;
			}

			// If no bins for the loccode, include the item by default
			if (!bins) {
				return true;
			}

			// Check if the sum of bin quantities is zero but they contain positive and negative values
			const binQuantities = bins.map(loc => Number(loc.quantity));
			const hasPositiveAndNegative = binQuantities.some(q => q > 0) && binQuantities.some(q => q < 0);

			return !hasPositiveAndNegative;
		}).map(item => {
			// Add the default bin to the item if it exists and loccode matches warehouse
			if (this.config.defaults.warehouse === item.loccode && this.itemdetails.bins[item.loccode]) {
				const bins = this.itemdetails.bins[item.loccode];
				const defaultBin = bins.find(bin => bin.defaultbin === '1');
				if (defaultBin) {
					item.defaultBin = defaultBin.bin; // Store the default bin in the item
				}
			}
			return item;
		});
	}

	getFilteredItemStock() {
		const filteredItems = [];
		this.itemdetails.itemstock.forEach(item => {
			const bins = this.itemdetails.bins[item.loccode];
			let includeItem = false;

			if (bins) {
				const binQuantities = bins.map(loc => Number(loc.quantity));
				const hasPositiveAndNegative = binQuantities.some(q => q > 0) && binQuantities.some(q => q < 0);
				const totalQuantity = binQuantities.reduce((sum, q) => sum + q, 0);

				// Filter the bins based on the total quantity and positive/negative conditions
				const filteredBins = bins.filter(bin => {
					const binQuantity = Number(bin.quantity);
					return binQuantity !== 0 || (!hasPositiveAndNegative || totalQuantity !== 0);
				});

				// If filtered bins exist, include them in the item
				if (filteredBins.length > 0) {
					includeItem = true;
					this.itemdetails.bins[item.loccode] = filteredBins; // Set the filtered bins for display
				}
			} else {
				// Include the item if there are no bins
				includeItem = true;
			}

			// Add the item to the filtered items list if it meets inclusion criteria
			if (includeItem) {
				filteredItems.push(item);
			}
		});

		return filteredItems;
	}


	private overrideXHR() {
		const originalXHR = window.XMLHttpRequest;
		const originalOpen = originalXHR.prototype.open;

		originalXHR.prototype.open = function(...args) {
			this.addEventListener('readystatechange', function() {
				if (this.readyState === 4) {
					// No operation, just suppressing the log
				}
			}, false);

			originalOpen.apply(this, args);
		};
	}


	// Method to start editing
	editAvgCost() {
		this.isEditingAvgCost = true;
		this.editingAvgCostValue = this.itemdetails.item.cost;
	}

	// Method to save the edited value
	saveAvgCost() {

		const payload = {
			stockid: this.stockid,
			avgcost: this.editingAvgCostValue
		}
		this.inventoryService.setAvgCost(payload).subscribe(result => {
			this.itemdetails.item.cost = this.editingAvgCostValue;
			this.isEditingAvgCost = false;
			this.loadItem();
		});

	}

	searchLibraries(event = false) {
		this.libraryOpen ? this.libraryOpen = false : this.libraryOpen = true;
		if (event) {
			this.loadItem();
			this.libraryOpen = false;
		}
	}

	cancelEditAvgCost() {
		this.isEditingAvgCost = false;
	}

	toggleLots() {
		// this.showItemLots = this.showItemLots ? false : true;

		this.modalService.open(this.controlledRef, { ariaLabelledBy: 'modal-title', size: 'controlled' }).result.then((result) => {

		}, (reason) => {

		});

	}

}